<script setup lang="ts">
import { CoreEventSource } from '@apps/main/new-desktop/core/models';

import { isFeatureToggleActive } from '@libs/feature-toggle';

import { useTripOverviewPageStore } from '../../stores';
import TripOverviewHeader from '../tripOverviewHeader/TripOverviewHeader.vue';
import FirstDayTripPriceCalendar from '../../../../core/components/FirstDayTripPriceCalendar.vue';
import { TripOverviewTemplateIds } from '../../models';

import TripItinerary from './TripItinerary.vue';
import TripItineraryLoader from './loaders/TripItineraryLoader.vue';

const tripOverviewPageStore = useTripOverviewPageStore();
</script>

<template>
  <div class="trip-overview-panel">
    <TripOverviewHeader :print-mode="false" />
    <div class="price-calendar-wrapper">
      <FirstDayTripPriceCalendar
        :id="TripOverviewTemplateIds.PriceCalendar"
        :show-month-select-dropdown="false"
        :source="CoreEventSource.TripOverview"
      />
    </div>
    <TripItinerary
      v-if="
        tripOverviewPageStore.anyItineraryLoaded &&
        !isFeatureToggleActive('loader')
      "
      :print-mode="false"
    />
    <TripItineraryLoader v-else />
  </div>
</template>

<style scoped lang="scss">
.trip-overview-panel {
  border-radius: var(--border-radius-12);
  background-color: var(--color-quaternary-70);
  .price-calendar-wrapper {
    padding: 0 var(--spacing-24);
    @include for-less-or-equal-than-extra-small-max {
      padding: 0;
    }
  }

  @include for-less-or-equal-than-small-max {
    border-radius: 0;
  }
}
</style>
